module.exports = __webpack_public_path__ + "media/images/edion/zh/popular-749e046e04e0ef7b4d1971010d48440c.png";